import { render, staticRenderFns } from "./AsigDevice.vue?vue&type=template&id=083ae088&scoped=true&"
import script from "./AsigDevice.vue?vue&type=script&lang=js&"
export * from "./AsigDevice.vue?vue&type=script&lang=js&"
import style0 from "./AsigDevice.vue?vue&type=style&index=0&id=083ae088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083ae088",
  null
  
)

export default component.exports